import { render } from "./PackageTile.vue?vue&type=template&id=40d892ae&scoped=true"
import script from "./PackageTile.vue?vue&type=script&lang=js"
export * from "./PackageTile.vue?vue&type=script&lang=js"

import "./PackageTile.vue?vue&type=style&index=0&id=40d892ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d892ae"]])

export default __exports__